import { render, staticRenderFns } from "./RiskAuditView.vue?vue&type=template&id=9bcab61c&"
import script from "./RiskAuditView.vue?vue&type=script&lang=js&"
export * from "./RiskAuditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports